import { createSelector } from 'reselect';

const getForceDefaultStadium = (state) => state?.pitchfx?.forceDefaultStadium;
const getDefaultStadium = (state) => state?.pitchfx.defaultStadium;

export const getStadiumConfig = createSelector(
    [getForceDefaultStadium, getDefaultStadium],
    (forceDefaultStadium, defaultStadium) => {
        return {forceDefaultStadium, defaultStadium};
    }
);